export default __webpack_public_path__ + "static/media/wolfgang-amadeus-phoenix.a2ac45ad.jpg";